import { Link } from 'lego-on-react';
import * as React from 'react';

import { CanvasAppContainer } from '../../canvas/CanvasApp/CanvasAppContainer';
import { Bem } from '../../service/Bem/Bem';
import { PcodeRenderData } from '../../typings/pcode';
import { ModalDecorator } from '../ModalDecorator/ModalDecorator';
import { Shape2, Shape2Icon } from '../Shape2/Shape2';

import './VideoCanvasIFrame.css';

export interface VideoCanvasIFrameProps {
    isVisible?: boolean;
    pcodeRenderData: PcodeRenderData;
    onCreativeIdUpdate: (creativeId: string) => void;
    onClose: () => void;
}

export enum VideoCanvasIFrameMessage {
    ready = 'ready',
    close = 'close',
    creativesSelect = 'creatives-select',
    adEnd = 'ad-end'
}

export enum VideoCanvasType {
    creatives = 'creatives',
    cpm_audio = 'cpm_audio',
    cpc = 'cpc',
    cpm = 'cpm',
    cpm_outdoor = 'cpm_outdoor',
    cpm_indoor = 'cpm_indoor',
    overlay = 'overlay'
}

export enum VideoCanvasPageType {
    presets = 'presets',
    creatives = 'creatives'
}

const BLOCK = 'video-canvas-iframe';

export class VideoCanvasIFrame extends React.PureComponent<VideoCanvasIFrameProps> {
    render(): React.ReactNode {
        const {
            isVisible,
            onClose,
            pcodeRenderData: { ads }
        } = this.props;

        return (
            <ModalDecorator
                visible={Boolean(isVisible)}
                theme={'clear'}
                cls={Bem.cls('video-canvas-iframe', 'modal')}
                onOutsideClick={onClose}
            >
                <Link cls={Bem.cls(BLOCK, 'close')} theme="pseudo" onClick={onClose}>
                    <Shape2 icon={Shape2Icon.close} width={15} height={15} />
                </Link>
                <div className={Bem.cls(BLOCK, 'iframe')}>
                    <CanvasAppContainer
                        videoPreviewData={ads[0]}
                        onClose={onClose}
                        onCreativesSelect={this.onCreativesSelect}
                    />
                </div>
            </ModalDecorator>
        );
    }

    private onCreativesSelect = (ids: number[]): void => {
        const [id] = ids;
        this.props.onCreativeIdUpdate(String(id));
    };
}
